<div class="izvor-wrapper p-fluid">
  <kodit-field fieldLabel="Format" fieldLabelFor="format-fajla">
    <kodit-dropdown
      formCtrlId="format-fajla"
      [formCtrl]="form.controls.format"
      [options]="dropdownItems"
    ></kodit-dropdown>
  </kodit-field>
</div>
